<template>
    <div class="card dashboard-card h-100">
        <div class="card-body">
            <span class="eyebrow">Leads attribution</span>
            <h4 class="card-title">Leads vs sold by source</h4>
            <p class="period-label">Period: {{ periodLabel }}</p>

            <div v-if="rows.length > 0">
                <GChart
                    :settings="{ packages: ['corechart'] }"
                    type="ColumnChart"
                    :data="chartData"
                    :options="chartOptions"
                    :resizeDebounce="500"
                ></GChart>
            </div>
            <div v-else class="empty-state">
                No leads source metrics available.
            </div>
        </div>
    </div>
</template>
<script>
import { GChart } from "vue-google-charts";

export default {
    name: "SummaryLeadsSourcesCard",
    components: {
        GChart,
    },
    props: {
        rows: {
            type: Array,
            required: true,
        },
        periodLabel: {
            type: String,
            default: "2020 - current",
        },
    },
    computed: {
        chartData() {
            return [["Source", "Leads", "SOLD"]].concat(this.rows);
        },
        chartOptions() {
            return {
                height: 280,
                backgroundColor: "transparent",
                chartArea: { left: 45, top: 15, width: "82%", height: 210 },
                colors: ["#3b82f6", "#16a34a"],
                legend: { position: "top", textStyle: { color: "#4c5968", fontSize: 11 } },
                hAxis: { textStyle: { color: "#4c5968", fontSize: 12 } },
                vAxis: { minValue: 0, textStyle: { color: "#4c5968", fontSize: 12 } },
                tooltip: { textStyle: { color: "#28323c", fontSize: 12 } },
            };
        },
    },
};
</script>
<style scoped>
.dashboard-card {
    border: 1px solid #dbe4ea;
    border-radius: 16px;
    box-shadow: 0 12px 30px rgba(31, 60, 90, 0.08);
    min-height: 450px;
    margin-bottom: 20px;
}
.dashboard-card .card-body {
    background-color: #ffffff;
}

.eyebrow {
    display: block;
    color: #6f7d8a;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.card-title {
    margin: 4px 0 16px;
    color: #24313f;
    font-size: 24px;
    font-weight: 700;
}

.period-label {
    margin: -10px 0 16px;
    color: #6f7d8a;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
}

.empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 220px;
    border: 1px dashed #d4dde5;
    border-radius: 12px;
    color: #71808f;
    font-size: 14px;
}
</style>
